import { ReactElement } from 'react';
import { Stack, Typography } from '@mui/material';

import { TimeWindowInfo, AccessFeature, OrderMFlexQR } from '~components/index';
import { PlanFeaturesTypes } from '~globals/types/enums';

import { DialogDetailsOrderContentRowItem } from '../../styles';
import { useDialogDetailsOrderContextContext } from '../../DialogDetailsOrderContext';

const DialogDetailsOrderData = (): ReactElement => {
  const { data } = useDialogDetailsOrderContextContext();

  return (
    <Stack spacing={4} direction="row">
      <Stack spacing={2} flex={1}>
        {data?.referenceId && (
          <DialogDetailsOrderContentRowItem>
            <Typography variant="body2" fontWeight="bold">
              Nro. de Orden
            </Typography>

            <Typography variant="body2">{data.referenceId}</Typography>
          </DialogDetailsOrderContentRowItem>
        )}

        <DialogDetailsOrderContentRowItem>
          <Typography variant="body2" fontWeight="bold">
            Dirección
          </Typography>

          <Typography variant="body2">{data?.address}</Typography>
        </DialogDetailsOrderContentRowItem>

        <DialogDetailsOrderContentRowItem>
          <Typography variant="body2" fontWeight="bold">
            Ventana horaria
          </Typography>

          <TimeWindowInfo
            allDay={data?.timeWindowAllDay ?? false}
            windowFrom1={data?.timeWindowFrom1 ?? null}
            windowFrom2={data?.timeWindowFrom2 ?? null}
            windowTo1={data?.timeWindowTo1 ?? null}
            windowTo2={data?.timeWindowTo2 ?? null}
          />
        </DialogDetailsOrderContentRowItem>

        {data?.contactName && (
          <DialogDetailsOrderContentRowItem>
            <Typography variant="body2" fontWeight="bold">
              Recibe
            </Typography>

            <Typography variant="body2">{data.contactName}</Typography>

            {data.contactIdentification && (
              <Typography variant="body2">
                {`Documento: ${data.contactIdentification}`}
              </Typography>
            )}

            {(data.contactPhone || data.contactMobile) && (
              <Typography variant="body2">
                {`Teléfono de contacto: ${
                  data.contactPhone ?? data.contactMobile
                }`}
              </Typography>
            )}

            {data.contactEmail && (
              <Typography variant="body2">
                {`Email: ${data.contactEmail}`}
              </Typography>
            )}
          </DialogDetailsOrderContentRowItem>
        )}

        {data?.requestPaymentOnDestiny && (
          <DialogDetailsOrderContentRowItem>
            <Typography variant="body2" fontWeight="bold">
              Metodo de pago
            </Typography>

            <Typography variant="body2">Pago contraentrega</Typography>

            <Typography variant="body2">
              {`Monto a abonar: ${data.cashOnDeliveryAmount ?? 'N/A'}`}
            </Typography>
          </DialogDetailsOrderContentRowItem>
        )}

        {data?.deliveryNotes && (
          <DialogDetailsOrderContentRowItem>
            <Typography variant="body2" fontWeight="bold">
              Comentarios
            </Typography>

            <Typography variant="body2">{data.deliveryNotes}</Typography>
          </DialogDetailsOrderContentRowItem>
        )}

        {data?.invoice && (
          <DialogDetailsOrderContentRowItem>
            <Typography variant="body2" fontWeight="bold">
              Factura
            </Typography>

            <Typography variant="body2">{data.invoice}</Typography>
          </DialogDetailsOrderContentRowItem>
        )}

        {data?.shipment && (
          <DialogDetailsOrderContentRowItem>
            <Typography variant="body2" fontWeight="bold">
              Remito
            </Typography>

            <Typography variant="body2">{data.shipment}</Typography>
          </DialogDetailsOrderContentRowItem>
        )}
      </Stack>

      {data?.qrcode && (
        <AccessFeature.Hidden
          validFeature={PlanFeaturesTypes.LimitPaid}
          type="notAccess"
        >
          <Stack>
            <OrderMFlexQR.Info
              qrData={data.qrcode}
              referenceId={data.referenceId}
            />
          </Stack>
        </AccessFeature.Hidden>
      )}
    </Stack>
  );
};

export default DialogDetailsOrderData;
